import type {GrupoPermissaoVm} from "@/domain/type/grupoPermissao.type";
import type {EmpresaVm} from "@/domain/type/empresa.type";
import * as zod from "zod";

export interface UsuarioColaboradorVm {
    publicId: string;
    nomeCompleto: string;
    apelido: string;
    cpf: string;
    cpfFormatado: string
    celular: string;
    imagem: string;
    email: string;
    status: number;
    statusDescricao: string;
    grupoPermissao: GrupoPermissaoVm
    empresas: EmpresaColaboradorCargoVm[]
    cgpe:string,
    isLoginHabilitado: boolean;

}


export interface UsuarioColaboradorStoreVm {
    publicId: string
    nome: string
    apelido:string
    imagem: string
    email: string
    sessao: string
    status: EStatusUsuario
    cgpe:string
    permissoes:string[]
    codigoGrupoPermissao:number
}

export enum EStatusUsuario {
    Cadastrado = 1,
    Confirmado = 2,
    Desativado = 3
}


export interface UsuarioSessoesVm {
    sessao: string;
    dispositivo: string;
    navegador: string;
    ip: string;
    ultimoIp:string;
    dataSessao: string;
    dataUltimaVerificacao: string;
}



export interface EmpresaColaboradorCargoVm {
    empresa: EmpresaVm
    cargoCodigo: number
    cargoDescricao: string
    colaborador: UsuarioColaboradorVm
}

export interface CargoVm {
    codigo: number
    descricao: string
}

export const zodUsuarioColaboradorVm = zod.object({
    publicId: zod.string(),
    nomeCompleto: zod.string(),
    apelido: zod.string(),
    cpf: zod.string(),
    cpfFormatado: zod.string()
},{message:"Selecione um colaborador"}).refine((val) => val != null);

export const zodCargoVm = zod.object({
    codigo: zod.number(),
    descricao: zod.string()
},{message:"Selecione um cargo"}).refine((val) => val != null);



export function dataAsUsuarioColaboradorVm (data: any) {
    return data as UsuarioColaboradorVm
}